export default __webpack_public_path__ + "static/media/icon_answer_percent.a5418a44.svg";